"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowDownIcon } from "lucide-react";
import { createContext, use } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";
export interface VirtualScrollContextValue {
  isAtEnd: boolean;
  scrollToEnd: () => void;
}
export const VirtualScrollContext = createContext<VirtualScrollContextValue | null>(null);
export function useVirtualScrollContext() {
  const ctx = use(VirtualScrollContext);
  if (!ctx) {
    throw new Error("useVirtualScrollContext must be used inside VirtualScrollContext.Provider");
  }
  return ctx;
}
export type ConversationScrollButtonProps = ComponentProps<typeof Button>;
export const ConversationScrollButton = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const {
    isAtEnd,
    scrollToEnd
  } = useVirtualScrollContext();
  let t1;
  if ($[3] !== className || $[4] !== isAtEnd || $[5] !== props || $[6] !== scrollToEnd) {
    t1 = !isAtEnd ? <Button className={cn("absolute bottom-4 left-[50%] translate-x-[-50%] rounded-full", className)} onClick={scrollToEnd} size="icon" type="button" variant="outline" {...props}><ArrowDownIcon className="size-4" /></Button> : null;
    $[3] = className;
    $[4] = isAtEnd;
    $[5] = props;
    $[6] = scrollToEnd;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};